export default __webpack_public_path__ + "static/19-4f5e0a3d2b74f49150b7787d236720f0.jpg";